import { EV_COMPANY_TYPE } from './company'

export enum RouteKeys {
  BANK_TRANSACTIONS = 'bankTransactions',
  CASHFLOW = 'cashflow',
  COMPANY = 'company',
  COMPANY_DOCUMENTS = 'companyDocuments',
  COST = 'cost',
  COST_MULTI_UPLOAD = 'costMultiUpload',
  DOCUMENTS_MULTI_UPLOAD = 'documentsMultiUpload',
  DOKUMENT_LIST = 'dokumentList',
  DOKUMENT = 'dokument',
  DOWNLOADS = 'downloads',
  EXPENSE_LIST = 'expenseList',
  INCOME = 'income',
  INCOME_LIST = 'incomeList',
  INVITE = 'invite',
  LOGIN = 'login',
  NO_COMPANY = 'noCompany',
  NO_SUBSCRIPTION = 'noSubscription',
  NOT_FOUND = 'notFound',
  ONBOARDING = 'onboarding',
  PAID_THROUGHS = 'paidThroughs',
  PARTNER_LIST = 'partnerList',
  PARTNER = 'partner',
  PROFILE = 'profile',
  QUARANTINE = 'quarantine',
  PULSE = 'pulse',
  RESET_PASSWORD = 'resetPassword',
  RESET_PASSWORD_CONFIRM = 'resetPasswordConfirm',
  ROOT = 'root',
  SELECT_COMPANY = 'selectCompany',
  SIGNUP = 'signup',
  SZAMLAZZ_ENTRY = 'szamlazzEntry',
  SZAMLAZZ_ENTRY_CHECK = 'szamlazzEntryCheck',
  SZAMLAZZ_ENTRY_CONNECT = 'szamlazzEntryConnect',
  SZAMLAZZ_ENTRY_INVITATION_STATUS = 'szamlazzEntryInvitationStatus',
  TRANSACTIONS = 'transactions', // route not exits, but used as constant
  QUARANTINE_LIST = 'quarantineList',
  TAX_LIST = 'taxList',
  TAXATION_DETAILS = 'taxationDetails',
  CHAT = 'chat',
  PAYMENT_TRANSACTIONS = 'paymentTransactions',
}

export const ROUTES: Record<RouteKeys, string> = {
  [RouteKeys.BANK_TRANSACTIONS]: '/dashboard/:company_id/cash-flow/bank-transactions',
  [RouteKeys.CASHFLOW]: '/dashboard/:company_id/cash-flow',
  [RouteKeys.COMPANY]: '/dashboard/:company_id/company',
  [RouteKeys.COST]: '/dashboard/:company_id/expense',
  [RouteKeys.COST_MULTI_UPLOAD]: '/dashboard/:company_id/expense-multi-upload',
  [RouteKeys.INCOME]: '/dashboard/:company_id/income',
  [RouteKeys.INVITE]: '/invite/:hash',
  [RouteKeys.LOGIN]: '/login',
  [RouteKeys.NO_COMPANY]: '/dashboard/no-company',
  [RouteKeys.NOT_FOUND]: '/not-found',
  [RouteKeys.ONBOARDING]: '/dashboard/:company_id/onboarding',
  [RouteKeys.SZAMLAZZ_ENTRY]: '/szamlazz/entry',
  [RouteKeys.SZAMLAZZ_ENTRY_CHECK]: '/szamlazz/entry/:company_id/check',
  [RouteKeys.SZAMLAZZ_ENTRY_CONNECT]: '/szamlazz/entry/:company_id/kszi',
  [RouteKeys.SZAMLAZZ_ENTRY_INVITATION_STATUS]: '/szamlazz/entry/:company_id/invitation-status',
  [RouteKeys.PAID_THROUGHS]: '/dashboard/:company_id/cash-flow/paid-throughs',
  [RouteKeys.PARTNER_LIST]: '/dashboard/:company_id/partners/:partner_type',
  [RouteKeys.PARTNER]: '/dashboard/:company_id/partner',
  [RouteKeys.PROFILE]: '/dashboard/profile',
  [RouteKeys.PULSE]: '/dashboard/:company_id/pulse',
  [RouteKeys.QUARANTINE]: '/dashboard/:company_id/quarantine',
  [RouteKeys.RESET_PASSWORD]: '/reset-password',
  [RouteKeys.RESET_PASSWORD_CONFIRM]: '/reset-password-confirm',
  [RouteKeys.ROOT]: '/dashboard',
  [RouteKeys.SELECT_COMPANY]: '/dashboard/select-company',
  [RouteKeys.SIGNUP]: '/signup',
  [RouteKeys.TRANSACTIONS]: '/dashboard/:company_id/transactions',
  // new subscription
  [RouteKeys.NO_SUBSCRIPTION]: '/dashboard/:company_id/no-subscription',
  // downloads
  [RouteKeys.DOWNLOADS]: '/download/:hash',
  [RouteKeys.DOCUMENTS_MULTI_UPLOAD]: '/dashboard/:company_id/documents-multi-upload',
  [RouteKeys.DOKUMENT]: '/dashboard/:company_id/document',
  // company level documents
  [RouteKeys.COMPANY_DOCUMENTS]: '/dashboard/:company_id/documents',
  // v2 transactions routes
  [RouteKeys.DOKUMENT_LIST]: '/dashboard/:company_id/transactions/documents',
  [RouteKeys.EXPENSE_LIST]: '/dashboard/:company_id/transactions/expenses',
  [RouteKeys.INCOME_LIST]: '/dashboard/:company_id/transactions/incomes',
  [RouteKeys.QUARANTINE_LIST]: '/dashboard/:company_id/transactions/quarantine-invoices',
  [RouteKeys.TAX_LIST]: '/dashboard/:company_id/transactions/taxes',
  // chat
  [RouteKeys.CHAT]: '/dashboard/:company_id/chat',
  // payment transactions
  [RouteKeys.PAYMENT_TRANSACTIONS]: '/dashboard/:company_id/cash-flow/transactions',
  // taxation details
  [RouteKeys.TAXATION_DETAILS]: '/dashboard/:company_id/taxation-details',
}

export const PULSE_REDIRECT_COMPANY_TYPES: Array<StaticEvCompanyType['id']> = [EV_COMPANY_TYPE]
